import types from '../actionTypes';

export const keepGameOpen = () => ({
  type: types.KEEP_GAME_OPEN,
});

export const resetGameOpenCloseState = () => ({
  type: types.RESET_GAME_OPEN_CLOSE_STATE,
});
